<template>
    <div
        class="swiper-slide swiper-slide-height"
        tabindex="0"
        :class="{'initial-swiper-slide': isInitialSwiperSlide}"
    >
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: "SwiperSlide",
    props: {
        isInitialSwiperSlide: {type: Boolean, required: false, default: false}
    },
}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
